import React from 'react';

const GeneralPrinciples = () => {
  return (
    <>
      {/* General Principles */}
      <h3 className="text-2xl font-bold text-gray-800 mb-6">General Principles</h3>
      
      <div className="mb-8">
        <h4 className="text-xl font-semibold text-gray-800 mb-4">Be explicit with your Web3 instructions</h4>
        <p className="text-gray-700 leading-relaxed mb-4">
          ASI1 models respond exceptionally well to clear, explicit instructions about Web3 operations and agentic behaviors. Being specific about your desired autonomous outcomes can help enhance results in DeFi and blockchain applications.
        </p>
        <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h5 className="font-semibold text-red-600 mb-2">❌ Less effective:</h5>
              <div className="bg-red-50 p-3 rounded border border-red-200">
                <code className="text-sm text-gray-800">Create a DeFi trading strategy</code>
              </div>
            </div>
            <div>
              <h5 className="font-semibold text-green-600 mb-2">✅ More effective:</h5>
              <div className="bg-green-50 p-3 rounded border border-green-200">
                <code className="text-sm text-gray-800">Create a comprehensive DeFi trading strategy. Include risk management protocols, multi-step execution logic, protocol integration considerations, and autonomous rebalancing mechanisms. Go beyond basic yield farming to create a fully-featured autonomous agent implementation.</code>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-8">
        <h4 className="text-xl font-semibold text-gray-800 mb-4">Add context to improve agentic performance</h4>
        <p className="text-gray-700 leading-relaxed mb-4">
          Providing context about the Web3 environment and autonomous goals behind your instructions helps ASI1 better understand your objectives and deliver more targeted agentic responses.
        </p>
        <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h5 className="font-semibold text-red-600 mb-2">❌ Less effective:</h5>
              <div className="bg-red-50 p-3 rounded border border-red-200">
                <code className="text-sm text-gray-800">NEVER execute transactions during high gas periods</code>
              </div>
            </div>
            <div>
              <h5 className="font-semibold text-green-600 mb-2">✅ More effective:</h5>
              <div className="bg-green-50 p-3 rounded border border-green-200">
                <code className="text-sm text-gray-800">This agent operates in a cost-sensitive DeFi environment where transaction fees directly impact profitability, so never execute transactions during high gas periods unless the potential yield significantly exceeds the gas costs.</code>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-12">
        <h4 className="text-xl font-semibold text-gray-800 mb-4">Be vigilant with DeFi examples & safety details</h4>
        <p className="text-gray-700 leading-relaxed mb-4">
          ASI1 models pay close attention to details and examples as part of autonomous instruction following. Ensure that your examples align with safe trading practices and compliance requirements while minimizing risky behaviors in DeFi environments.
        </p>
      </div>
    </>
  );
};

export default GeneralPrinciples;
